import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

const useNotLoggedInRedirect = (path = '/') => {
  const router = useRouter();
  const isLoggedIn = useSelector(state => state.auth.loggedIn);
  const currentUserChecked = useSelector(state => state.auth.currentUserChecked);

  useEffect(() => {
    router.prefetch(path);
  }, [path, router]);

  useEffect(() => {
    if (!isLoggedIn && currentUserChecked) {
      router.push(path);
    }
  }, [isLoggedIn, path, router, currentUserChecked]);
};

export default useNotLoggedInRedirect;
